<div class="width-lg max-width-lg">
  <div>
    <strong>{{ customer?.code }}</strong>
    <span class="float-right">
      <nz-tag [nzColor]="customer?.status != null ? color[customer.status] : ''">
        {{ customer?.status != null ? status[customer.status] : '' }}
      </nz-tag>
    </span>
  </div>
  <div nz-tooltip="{{ customer?.name }}" [nzTooltipPlacement]="'top'">
    <small>{{ customer?.name }}</small>
  </div>
  <nz-divider class="m-none"></nz-divider>
</div>
